import { Devices } from "../../../../styles";
import styled from "styled-components";

const Subtitle = styled.h2`
  color: #333333;
  font-size: 0.875rem;
  font-weight: lighter;
  text-align: left;
  @media ${Devices.desktop} {
    font-size: 1rem;
  }
`;

export default Subtitle;
